// extracted by mini-css-extract-plugin
module.exports = {"notFoundContainer":"notFound_notFoundContainer__UzCoi","notFoundText":"notFound_notFoundText__io02N","statusText":"notFound_statusText__rpeEn"};